import { PeriodAttendanceForMonth } from "@godalming/api-types";
import { portalApi } from "@services/api/portalApi";

export async function getStudentMonthAttendance(studentNo: string) {
    try {
        const response = await portalApi.get<PeriodAttendanceForMonth[]>(`/students/${studentNo}/month-attendance`);
        return response.data;
    } catch (error) {
        console.error("Error fetching student month attendance:", error);
        throw error;
    }
}
